module.exports = __webpack_public_path__ + "img/hsa-fsa-eligible-badge.51a7f67a.svg";